import { AnyAction, IPartialReducer } from "../../../core/core-redux/reduxTypes";
import { LayerLoadState } from "../layerLoad.reducer";

export const layerLoadingPartialReducer: IPartialReducer<LayerLoadState> = (
    state: LayerLoadState,
    action: AnyAction
) => {
    const loadingLayerIds = [...state.loadingLayerIds, action.layerId];
    return {
        loadingLayerIds: loadingLayerIds,
        loading: loadingLayerIds.length > 0,
    };
};
